import { createSelector } from 'reselect';
import { getRoaQuoteTools } from './index';
import { FORM_STATUS, API_CALL_STATUS } from '../../reducers/status';

export const getcountyQuoteTool = createSelector(
    getRoaQuoteTools,
    (roaQuoteTools) => roaQuoteTools.afyaImaraCountyQuoteTool
);

export const getcountyQuoteToolForm = createSelector(
    getcountyQuoteTool,
    (countyQuoteTool) => countyQuoteTool.form
);

const makeGetFieldForm = (fieldId) =>
    createSelector(getcountyQuoteToolForm, (form) => form[fieldId]);

export const getcountyQuoteToolFormValid = createSelector(
    getcountyQuoteTool,
    (countyQuoteTool) => countyQuoteTool.formStatus === FORM_STATUS.VALID
);

export const getSelectedForm = createSelector(
    getcountyQuoteTool,
    (CountyQuoteTool) => CountyQuoteTool.selectedForm
);
export const getCountyPremiumAmount = createSelector(
    getcountyQuoteTool,
    (CountyQuoteTool) => CountyQuoteTool.CountyPremiumAmount
);

export const getRoaCmbObject = createSelector(
    getcountyQuoteTool,
    (CountyQuoteTool) => CountyQuoteTool.roaCmbObject
);

export const getShowError = createSelector(
    getcountyQuoteTool,
    (CountyQuoteTool) =>
        CountyQuoteTool.apiCallStatus === API_CALL_STATUS.FAILURE
);

export const getIsApiPending = createSelector(
    getcountyQuoteTool,
    (CountyQuoteTool) =>
        CountyQuoteTool.apiCallStatus === API_CALL_STATUS.PENDING
);

export const getCalculateDisabled = createSelector(
    getcountyQuoteTool,
    (CountyQuoteTool) => {
        return (
            CountyQuoteTool.formStatus === FORM_STATUS.INVALID ||
            CountyQuoteTool.apiCallStatus === API_CALL_STATUS.PENDING
        );
    }
);
export const getAgeBracket = makeGetFieldForm('ageBracket');
export const getSpouse = makeGetFieldForm('spouseCover');
export const getSpouseAge = makeGetFieldForm('spouseAge');
export const getCoverChild = makeGetFieldForm('childCover');
export const getInpatientCover = makeGetFieldForm('inPatient');
export const getOutPatientCover = makeGetFieldForm('outPatient');
export const get18ChildValue = makeGetFieldForm('child_18');
